/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ApprenantSelectorSearch
 */
export interface ApprenantSelectorSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSelectorSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSelectorSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSelectorSearch
     */
    registreNational?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof ApprenantSelectorSearch
     */
    dateNaissance?: DateSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantSelectorSearch
     */
    nationalite?: StringListSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApprenantSelectorSearch
     */
    selectedApprenantIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApprenantSelectorSearch
     */
    excludedApprenantIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprenantSelectorSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ApprenantSelectorSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantSelectorSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantSelectorSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ApprenantSelectorSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantSelectorSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ApprenantSelectorSearch interface.
 */
export function instanceOfApprenantSelectorSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantSelectorSearchFromJSON(json: any): ApprenantSelectorSearch {
    return ApprenantSelectorSearchFromJSONTyped(json, false);
}

export function ApprenantSelectorSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantSelectorSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'registreNational': !exists(json, 'registreNational') ? undefined : TextSearchFromJSON(json['registreNational']),
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : DateSearchFromJSON(json['dateNaissance']),
        'nationalite': !exists(json, 'nationalite') ? undefined : StringListSearchFromJSON(json['nationalite']),
        'selectedApprenantIds': !exists(json, 'selectedApprenantIds') ? undefined : json['selectedApprenantIds'],
        'excludedApprenantIds': !exists(json, 'excludedApprenantIds') ? undefined : json['excludedApprenantIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ApprenantSelectorSearchToJSON(value?: ApprenantSelectorSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'registreNational': TextSearchToJSON(value.registreNational),
        'dateNaissance': DateSearchToJSON(value.dateNaissance),
        'nationalite': StringListSearchToJSON(value.nationalite),
        'selectedApprenantIds': value.selectedApprenantIds,
        'excludedApprenantIds': value.excludedApprenantIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

